// extracted by mini-css-extract-plugin
export default {"release-notes-collapsible":"t_bM","header-collapsible":"t_bN"};